import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Issuelistsr } from '../issuelistsr/issuelistsr';
import { Notes } from '../notes/notes';
import { Api } from '../../services/api';
import { Subscription } from 'rxjs';
import { ToasterMessages } from '../toaster-messages/toaster-messages';
import { Auth } from '../../services/auth';
import { LoaderComponent } from '../loader/loader';
import { WidthHeightDirective } from '../../widthHeightDirective';
import { Dialog } from 'primeng/dialog';
import { ButtonModule } from 'primeng/button';


@Component({
  selector: 'app-supervisor',
  imports: [CommonModule, Issuelistsr, Notes, ToasterMessages, LoaderComponent, WidthHeightDirective, Dialog, ButtonModule],
  templateUrl: './supervisor.html',
  styleUrl: './supervisor.scss',
  standalone: true
})
export class Supervisor implements OnInit, OnDestroy {
  // Default properties for bindings 
  headerTitleText: string = 'Hello';
  headerSubtitleText: string = 'Welcome to IOA Pulse Agent.';
  userName: string = ''; // Survey and notes block toggles 
  surveyBlock: boolean = false;
  notesBlock: boolean = false; // Icons (dummy paths for now) 

  chatMainIcon = 'assets/images/chatbot-main-icon.svg';
  chatbotheadericon = 'assets/images/chatbotheadericon.svg';
  dailySurveyLogo = 'assets/images/daily-survey-logo.svg';


  dailySurveyMenuIcon = 'assets/images/dailyiconnew.svg'; // new icon default daily

  dailySurveyDisabledMenuIcon = 'assets/images/dailydisablediconnew.svg'; // new icon disabled daily

  notesMenuEnabledIcon = 'assets/images/notes-icon-enabled.svg';
  notesMenuDisabledIcon = 'assets/images/notes-icon-disabled.svg';

  notesTooltipText: string = 'Notes';
  notesBlockData: any = {}; // placeholder 
  serveyData: any = {}; // placeholder 
  issueFrequency: string = 'd'; // default daily // --- Dummy methods to avoid template errors --- 

  data = {};
  notesServiceSubscription: Subscription | undefined;
  userDetails: any = {};
  confirmLogout: boolean = false;
  logoutIcon = 'assets/images/logout-black.svg';
  logoutIconHover = 'assets/images/logout-blue.svg';


  constructor(private apiService: Api, private authService: Auth) { }

  ngOnInit(): void {
    this.userDetails = this.authService.getUserDetails();
    this.userName = this.userDetails.name || '';
    this.notesServiceSubscription = this.apiService.notesState$.subscribe((state: any) => (this.notesBlock = state.open, this.notesBlockData = state.data));
  }

  ngOnDestroy(): void {
    if (this.notesServiceSubscription) {
      this.notesServiceSubscription.unsubscribe();
    }
  }

  getUserType(): string {
    return 'sv'; // supervisor by default 
  }
  checkDailyServey(): boolean {
    return true;
  }
  checkWeeklyServey(): boolean { return true; }
  checkMonthlyServey(): boolean { return true; }
  checkQuarterlyServey(): boolean { return true; }
  getDailySurveyMenuIcon(): string {
    return '2'; // tick 
  }
  getWeeklySurveyMenuIcon(): string {
    return '0';
  }
  getMonthlySurveyMenuIcon(): string {
    return '0';
  }
  getQuarterlySurveyMenuIcon(): string {
    return '0';
  }
  getNotesIconDisplay(): boolean {
    return true;
  }
  openServey(type: string): void {
    this.surveyBlock = true; this.issueFrequency = type;
  }
  openNotes(): void {
    console.log("openNotes");
    this.notesBlock = true;
    this.notesBlockData = this.data;
    this.notesTooltipText = ''; // Clear the tooltip text when opening notes
  }
  closeNotes(event: any): void {
    this.notesBlock = false;
  }
  getIssues(type: string): void {
    this.issueFrequency = type;
  }

  get logoutDisplayIcon(): string {
    return this.logoutIcon;
  }

  logout(): void {
    console.log('Logging out...');
    this.authService.initiateLogout();
  }


}
